export default "__VITE_ASSET__B7Fp5Q9O__"